exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modalInfo__img-wrap[data-v-e6bf8abe]{position:relative;width:100%}.modalInfo__img[data-v-e6bf8abe]{position:absolute;top:0;left:0;width:100%;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6bf8abe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modal.vue
// module id = 146
// module chunks = 0 1